import {Component, OnInit, ViewChild} from '@angular/core';
import {VoilaUserService} from '@services/voila-user.service';
import {ProductViewComponent} from '@app/product-view/product-view.component';
import {ProductService} from '@services/product.service';
import {Observable} from 'rxjs';
import {Product} from '@services/model/product';
import {CommonModule} from '@angular/common';

@Component({
  selector: 'app-product-preview',
  templateUrl: './product-preview.component.html',
  standalone: true,
  imports: [CommonModule, ProductViewComponent],
})
export class ProductPreviewComponent implements OnInit {
  @ViewChild(ProductViewComponent, {static: true})
  productViewComponent: ProductViewComponent;

  product$: Observable<Product>;

  constructor(
    private readonly productService: ProductService,
    private readonly userService: VoilaUserService,
  ) {}

  ngOnInit() {
    this.product$ = this.productService.productForUser(this.userService.currentUser().id);
  }
}
